/*!
 * Local Project Js File
 *
 */

window.requestAnimFrame = (function(){
  return  window.requestAnimationFrame       ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame    ||
          window.oRequestAnimationFrame      ||
          window.msRequestAnimationFrame     ||
          function( callback ){
            window.setTimeout(callback, 1000 / 60);
          };
})();

(function () {

  "use strict";

  var myApp = {

  }

  myApp.init = function() {

    var ticking = false;
    var last_known_scroll_position;


    ruralApp.Flexslider.initFlex('.flexslider',{animation: 'fade'});
    ruralApp.MagnificPopup.initMagnific('.gallery', {delegate: 'a', type: 'image', gallery: { enabled:true }});


    if (typeof $.fn.slick === 'undefined') {
      return;
    }

    $('.equipo-slick').slick({
      slidesToShow: 3,
      dots: false,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
    });

  }




  document.addEventListener('DOMContentLoaded', function() {
    myApp.init();
  }, false);


})();
